import { render } from "./ListCostLabels.vue?vue&type=template&id=e9233cb4"
import script from "./ListCostLabels.vue?vue&type=script&lang=js"
export * from "./ListCostLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__